var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownSFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1 30.5L31.9 18.9C32.4 18.1 31.8 17.1 30.9 17.1H17.3C16.4 17.1 15.8 18.1 16.3 18.9L23.1 30.5C23.5 31.3 24.7 31.3 25.1 30.5Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3578 19.4678C14.3961 17.9047 15.5812 16 17.3 16H30.9C32.6188 16 33.8039 17.9047 32.8422 19.4679L26.0645 31.0298C25.2479 32.5901 22.9521 32.5901 22.1355 31.0298L15.3578 19.4678ZM17.2187 18.2815C17.2187 18.2838 17.2185 18.2941 17.2328 18.317C17.2383 18.3258 17.2437 18.3347 17.249 18.3437L24.049 29.9437C24.0593 29.9614 24.0692 29.9793 24.0785 29.9975C24.0842 29.9989 24.0916 30 24.1 30C24.1084 30 24.1158 29.9989 24.1215 29.9975C24.1308 29.9793 24.1407 29.9614 24.151 29.9437L30.951 18.3437C30.9563 18.3347 30.9617 18.3258 30.9672 18.317C30.9815 18.2941 30.9813 18.2838 30.9812 18.2815L30.9812 18.2812C30.9812 18.2754 30.9795 18.2625 30.9699 18.2458C30.9601 18.2286 30.9469 18.216 30.9354 18.209C30.9266 18.2037 30.9169 18.2 30.9 18.2H17.3C17.2831 18.2 17.2734 18.2037 17.2646 18.209C17.2531 18.216 17.2399 18.2286 17.2301 18.2458C17.2205 18.2625 17.2187 18.2754 17.2187 18.2812C17.2187 18.2813 17.2187 18.2814 17.2187 18.2815Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2,
    height: 16.2,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownSFilled);
export default __webpack_public_path__ + "static/media/icon_down_s_filled.2b45d8e6.svg";
export { ForwardRef as ReactComponent };